import { TreeStructure } from "react-migration/components/CheckboxTree";
import { AttributeFilter } from "../../types";
import { ConstraintStatus } from "./types";

export const setCategoryTree = (layerId: string, categoryTree: TreeStructure) => ({
  type: "SET_LAYER_CATEGORY_TREE" as const,
  layerId,
  categoryTree,
});

export const setVisibleCategories = (layerId: string, visibleCategoryIds: string[]) => ({
  type: "SET_LAYER_VISIBLE_CATEGORIES" as const,
  layerId,
  visibleCategoryIds,
});

export const setHiddenStatuses = (layerId: string, hiddenStatuses: ConstraintStatus[]) => ({
  type: "SET_LAYER_HIDDEN_STATUSES" as const,
  layerId,
  hiddenStatuses,
});

export const setLayerConfigHash = (layerId: string, layerConfigHash: string) => ({
  type: "SET_LAYER_CONFIG_HASH" as const,
  layerId,
  layerConfigHash,
});

export const setDisplayBy = (layerId: string, displayBy: string) => ({
  type: "SET_LAYER_DISPLAY_BY" as const,
  layerId,
  displayBy,
});

export const setHiddenDesignationAttributes = (
  layerId: string,
  attributeFilter: AttributeFilter,
  hiddenDesignationAttributes: string[]
) => ({
  type: "SET_LAYER_HIDDEN_DESIGNATION_ATTRIBUTES" as const,
  layerId,
  attributeFilter,
  hiddenDesignationAttributes,
});
